module.exports = __webpack_public_path__ + "files/479a01794b5f71bcdf9521a8019a5c62.svg";